import React, { useContext } from "react";

import { AWSLanguage, Subtitle } from "chq";
import { t } from "app/utils";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import SubtitleTab from "./SubtitleTab";

interface SubtitlesTabsProps {
  activeLanguage?: Subtitle;
  changingLanguage: boolean;
  onLanguageChange: (subtitle: Subtitle | AWSLanguage) => void;
}

const SubtitleTabs: React.FC<SubtitlesTabsProps> = ({
  activeLanguage,
  changingLanguage,
  onLanguageChange
}) => {
  const { data: { pendingSubtitle, subtitles } } = useContext(CreatomateContext);
  const availableSubtitles = subtitles.filter(subtitle => !subtitle.deleted);

  return (
    <ul role="tablist" aria-label={t("Subtitles options")} className="nav nav-tabs">
      {pendingSubtitle && (
        <SubtitleTab
          activeLanguage={activeLanguage?.label || activeLanguage?.transcription}
          subtitle={pendingSubtitle}
          loading
          onLanguageChange={onLanguageChange}
        />
      )}
      {availableSubtitles.map(subtitle => (
        <SubtitleTab
          activeLanguage={activeLanguage?.label || activeLanguage?.transcription}
          changingLanguage={changingLanguage}
          key={subtitle.id}
          subtitle={subtitle}
          onLanguageChange={onLanguageChange}
        />
      ))}
    </ul>
  );
};

export default SubtitleTabs;
